import React from 'react';

import { removeNulls } from '@trqk/utils';

// import { Dropdown } from '../..';

import { SourceEarningsPerPlayRanges } from '../dumbbell/SourceEarningsPerPlayRanges';

interface Props {
    dashboard: ProIngestionDashboard;
}

export const PayoutRanges = ({ dashboard }: Props): JSX.Element => {
    const sources = removeNulls(dashboard.sources);

    return (
        <>
            <div className="flex justify-start items-center mb-8">
                <h4>Source Per-Performance-Payout Range</h4>
                {/*
                    Uncomment to show chart display controls

                <div className="mx-4">by</div>
                <div className="w-1/5">
                    <Dropdown
                        disabled={true}
                        options={[
                            {
                                value: 'source_name',
                                label: 'Source',
                            },
                        ]}
                    />
                </div>
                */}
            </div>
            <SourceEarningsPerPlayRanges
                chartDivId="track-earnings-per-play-ranges"
                height={600}
                sources={sources}
            />
        </>
    );
};
